import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export interface INotificationPreference {
  field: string;
  value: boolean;
}

export const webNotificationsApi = createApi({
  reducerPath: 'webNotificationsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['notifications'],
  endpoints: (builder) => ({
    getNotificationPreferences: builder.query<{ response: INotificationPreference[] }, void>({
      query: () => ({ url: '/api/v1/notifications/preferences', method: 'GET' }),
      providesTags: ['notifications'],
    }),
    updatePreference: builder.mutation<{ success: boolean }, FormData>({
      query: (formData) => ({
        url: '/api/v1/notifications/preference',
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['notifications'],
    }),
  }),
});

export const { useGetNotificationPreferencesQuery, useLazyGetNotificationPreferencesQuery, useUpdatePreferenceMutation } = webNotificationsApi;


